import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import ContraComponent from '../components/contra.component';
import { selectContrasQueryItems } from '../../../../../../redux/fms/contras/selector';
import { contras } from '../../../../../../redux/fms/contras/action';
import { accountLedgers } from '../../../../../../redux/account-ledgers/action';
import { selectAccountLedgersListItems } from '../../../../../../redux/account-ledgers/selector';

const ManagementContra = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const contrasQueryData = useSelector(selectContrasQueryItems)
  const accountledgersItems = useSelector(selectAccountLedgersListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [selectedContras, setSelectedContras] = useState<any>([])

  const fetchContrasQueryById = () => {
    dispatch(contras.query({
      url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/contras/query`,
      entity: 'contras',
      jsonData:
      {
        Records: [
          {
            "Id": parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedContras({ ...selectedContras, [field]: event });
  }

  useEffect(() => {
    dispatch(accountLedgers.list({
      url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-applications/accounts/ledgers/fetch`,
      entity: 'accountLedgers',
      jsonData: {}
    })).then(() => {
      if (parmas?.id > 0) {
        fetchContrasQueryById()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }
    })
  }, [])

  useEffect(() => {
    if (isQuery) {
      setSelectedContras(contrasQueryData?.result?.items)
    }
  }, [isQuery])

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(contras.resetAction({ actionType: 'update' }))
      await dispatch(contras.update({
        url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/contras`,
        entity: 'contras',
        jsonData:
        {
          Records: [
            {
              ...selectedContras
            }
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(contras.resetAction({ actionType: 'create' }))
      await dispatch(contras.create({
        url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/contras`,
        entity: 'contras',
        jsonData:
        {
          Records: [
            {
              ...selectedContras
            }
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/management/e-applications/fms/contras')
  }

  return (
    <>
      {contrasQueryData?.isLoading ? <PageLoader /> :
        <ContraComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedContras={selectedContras}
          back={back}
          handleFormSubmit={handleFormSubmit}
          ledgersList={accountledgersItems?.result?.items}
        />
      }
    </>
  )
}

export default ManagementContra;